import i18n from "./translation/i18n";
import { Project } from "./@types/types";

export const name = "Shoeb";
export const fullName = "Shoeb Tamboli";
export const role = "Full Stack Developer";
export const greeting = "Hello I'm";
export const profileImageUrl =
  "https://res.cloudinary.com/dyyyuduhp/image/upload/w_500,f_webp,q_80/v1711707303/29739085_295104167689512_5146263542445375488_n_wkz93q.jpg";
export const description = [
  "A Full stack developer who is passionate about building bridges in code.",
];
export const footerText = "All rights reserved.";
export const githubUrl = "https://github.com/Shoebtamboli";
export const linkedInUrl =
  "https://www.linkedin.com/in/shoeb-tamboli-42548545/";

export const projects: Project[] = [
  {
    id: 1,
    name: i18n.t("FOODY-Food Ordering"),
    description: i18n.t(
      "The Foody-food ordering app is designed to ease the process of ordeing food for medium-sized businesses. This application allows users to select items from menu, add to cart, place order, online payment / checkout process and also user can checkout the status of placed order. Built with MERN stack."
    ),
    technologies: [
      "Nodejs",
      "Mongodb",
      "React",
      "HTML",
      "CSS",
      "MaterialUI",
      "Docker",
    ],
    imageUrl: [
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712516923/project_images/Screenshot_2024-04-07_at_21.05.04_n3jtzk.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712516920/project_images/Screenshot_2024-04-07_at_21.05.36_kkzie9.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712516907/project_images/Screenshot_2024-04-07_at_21.06.20_robnyx.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712516901/project_images/Screenshot_2024-04-07_at_21.06.46_cu1tno.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712516897/project_images/Screenshot_2024-04-07_at_21.06.26_h66zsh.png",
    ],
    type: "full-stack",
    githubUrl: "https://www.buymeacoffee.com/shoebtamboli",
    projectLink: "https://lovefoody.netlify.app",
    features: [
      "User Authentication",
      "User Authorization",
      "Add to cart",
      "Checkout",
      "Payment",
      "Order history",
      "Email service",
      "Material UI v5",
      "React hooks",
      "React Context API",
      "React Hook Form + Yup",
      "ESLint & Prettier",
      "React router v6",
      "Fully responsive, and works across all modern/supported browsers & devices",
    ],
  },
  {
    id: 2,
    name: i18n.t("Inventory Management"),
    description: i18n.t(
      "The Inventory Management App is designed to streamline the process of managing inventory for small to medium-sized businesses. This application allows users to track product inventory, manage stock levels, and generate reports on inventory status. Built with React and Node.js, it offers a user-friendly interface and robust backend services for efficient inventory management."
    ),
    technologies: [
      "Nodejs",
      "Mongodb",
      "React",
      "HTML",
      "CSS",
      "MaterialUI",
      "Docker",
    ],
    imageUrl: [
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712437697/project_images/orders_iisdt9.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712437745/project_images/login_ewu9zw.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712437689/project_images/orderDetails_gx1rol.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712437685/project_images/orderAdd_dcsnbu.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712437720/project_images/dashboard_uuojpz.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1712437726/project_images/settings_hindi_dyzkwt.png",
    ],
    type: "full-stack",
    githubUrl: "https://www.buymeacoffee.com/shoebtamboli",
    projectLink: "https://ruralnventory.netlify.app",
    features: [
      "User Authentication",
      "User Authorization",
      "Multiple Language support",
      "Invoice Generation",
      "Dashboard for analysis",
      "Different organization support",
      "Email service",
      "Material UI v5",
      "React hooks",
      "React Context API",
      "React Hook Form + Yup",
      "ESLint & Prettier",
      "React router v6",
      "Fully responsive, and works across all modern/supported browsers & devices",
    ],
  },
  {
    id: 3,
    name: i18n.t("Inquisitive Institute"),
    description: i18n.t(
      "The Inquisitive IT Institute's website is a modern, interactive platform designed to showcase its educational offerings in the IT field. It serves the potential students to explore courses, faculty expertise, and the unique learning opportunities available. The site has been developed using React and MUI."
    ),
    technologies: ["React", "HTML", "CSS", "MaterialUI"],
    imageUrl: [
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463469/project_images/image1_vvtaxm.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463463/project_images/image2_h0lcvo.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463461/project_images/image3_wswl99.png",
    ],
    type: "frontend",
    githubUrl: "https://github.com/Shoebtamboli/inquisitive-website-template",
    projectLink: "https://inquisitive-it-institute.netlify.app/",
    features: [
      "Material UI v5",
      "React hooks",
      "React Context API",
      "React Hook Form + Yup",
      "ESLint & Prettier",
      "React router v6",
      "Fully responsive, and works across all modern/supported browsers & devices",
    ],
  },
  {
    id: 4,
    name: i18n.t("Healthify Dashboard"),
    description: i18n.t(
      "This is a dashboard template of an hospital management system with features like patient info, appointments etc"
    ),
    technologies: ["React", "Typescript", "HTML", "CSS", "MaterialUI"],
    type: "frontend",
    imageUrl: [
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463712/project_images/image1_wahsuw.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463706/project_images/image3_crkz6r.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463703/project_images/image2_gcgqff.png",
    ],
    githubUrl: "https://github.com/Shoebtamboli/React-mui-Dashboard-Hospital",
    projectLink: "https://healthify-dashboard.netlify.app/",
    features: [
      "Material UI v5",
      "Typescript",
      "React hooks",
      "React Context API",
      "React Hook Form + Yup",
      "ESLint & Prettier",
      "E-Charts",
      "Formik",
      "recharts",
      "State management Zustand",
      "fullcalendar",
      "Kanban",
      "Dark/Light Mode",
      "Change Color Theme",
      "Easy to customize",
      "Private / Public routes (React router v6)",
      "Auth Module",
    ],
  },
  {
    id: 5,
    name: i18n.t("MyStore commerce"),
    description: i18n.t(
      "MyStore commerce website is an e-commerce platform built using React and Material-UI, showcasing a clean and modern user interface for shopping online. It likely features like storefront, shopping cart, checkout process, filtering and product details capabilities, all designed with responsiveness and user experience in mind."
    ),
    type: "frontend",
    technologies: ["React", "Typescript", "HTML", "CSS", "MaterialUI"],
    imageUrl: [
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463773/project_images/image1_a2oily.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463775/project_images/image2_x5vlld.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463771/project_images/image3_w4xpik.png",
    ],
    githubUrl: "https://github.com/Shoebtamboli/React-zustand-ecommerce",
    projectLink: "https://react-mui-ecommerce.netlify.app/",
    features: [
      "Material UI v5",
      "Typescript",
      "React hooks",
      "React Context API",
      "React Hook Form + Yup",
      "ESLint & Prettier",
      "Formik",
      "State management Zustand",
      "Dark/Light Mode",
      "Private / Public routes (React router v6)",
      "Auth Module",
      "filtering and checkout",
      "Fully responsive, and works across all modern/supported browsers & devices",
    ],
  },
  {
    id: 6,
    name: i18n.t("Blog app"),
    description: i18n.t(
      "This is a template of a blog app with features like blog list, details, contact form."
    ),
    technologies: ["React", "Typescript", "HTML", "CSS", "MaterialUI"],
    type: "frontend",
    imageUrl: [
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463844/project_images/image1_lmrx70.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463845/project_images/image2_g6cjci.png",
    ],
    githubUrl: "https://github.com/Shoebtamboli/React-mui-blog-app",
    projectLink: "https://react-mui-blog-app.netlify.app/",
    features: [
      "Material UI v5",
      "Typescript",
      "React Context API",
      "ESLint & Prettier",
      "Formik",
      "Fully responsive, and works across all modern/supported browsers & devices",
    ],
  },
  {
    id: 7,
    name: i18n.t("Netflix clone"),
    description: i18n.t(
      "This project is a clone of popular netflix site. It uses TMDB api for the data."
    ),
    technologies: ["React", "Typescript", "HTML", "CSS", "MaterialUI"],
    type: "frontend",
    imageUrl: [
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463864/project_images/image1_tvsxue.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463862/project_images/image2_x52t3i.png",
    ],
    githubUrl: "https://github.com/Shoebtamboli/react-mui-netflix-clone",
    projectLink: "https://netflix-sphere.vercel.app/",
    features: [
      "Material UI v5",
      "Typescript",
      "React hooks",
      "React Context API",
      "Language setting",
      "Auth Module",
      "React-player",
      "React router v6",
    ],
  },
  {
    id: 8,
    name: i18n.t("Dental Clinic Landing Page"),
    description: i18n.t("This is a website template for a dental clinic."),
    technologies: ["React", "HTML", "CSS", "MaterialUI"],
    type: "frontend",
    imageUrl: [
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463874/project_images/image1_yrulgl.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463871/project_images/image3_mzc4u9.png",
      "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708463867/project_images/image2_v05zjz.png",
    ],
    githubUrl: "https://github.com/Shoebtamboli/dental-clinic-landing-page",
    projectLink: "https://dental-landing-page.vercel.app/",
    features: [
      "Material UI v5",
      "ESLint & Prettier",
      "Fully responsive, and works across all modern/supported browsers & devices",
    ],
  },
];

export const skillSet = [
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464092/css-3_vtc4um.svg",
    alt: "css",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464093/docker_kvyr6e.svg",
    alt: "docker",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464094/github_lepadt.svg",
    alt: "github",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464094/graphql_bwbkz2.svg",
    alt: "graphql",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464095/html-5_cdlekv.svg",
    alt: "html",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464096/js_thqxor.svg",
    alt: "js",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464098/mongodb_hcodjf.svg",
    alt: "mongodb",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464099/nodejs_bjjlnd.svg",
    alt: "nodejs",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464101/react_wvnxjv.svg",
    alt: "react",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464102/typescript_r2ny9o.svg",
    alt: "typescript",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464100/python_xedacz.svg",
    alt: "python",
  },
  {
    src: "https://res.cloudinary.com/dyyyuduhp/image/upload/v1708464097/material-ui_ji6egc.svg",
    alt: "material",
  },
];

export const technologyIcons: Record<string, string> = {
  React:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464101/react_wvnxjv.svg",
  HTML: "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464095/html-5_cdlekv.svg",
  CSS: "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464092/css-3_vtc4um.svg",
  Docker:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464093/docker_kvyr6e.svg",
  Github:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464094/github_lepadt.svg",
  Graphql:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464094/graphql_bwbkz2.svg",
  Javascript:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464096/js_thqxor.svg",
  Mongodb:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464098/mongodb_hcodjf.svg",
  Nodejs:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464099/nodejs_bjjlnd.svg",
  Typescript:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464102/typescript_r2ny9o.svg",
  Python:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464100/python_xedacz.svg",
  MaterialUI:
    "https://res.cloudinary.com/dyyyuduhp/image/upload/f_webp,q_80/v1708464097/material-ui_ji6egc.svg",
};
